import type { UseToastOptions } from '../useToast';

export const defaultOptions = {
  variant: 'subtle',
  duration: 10000,
  isClosable: true,
  position: 'top-right',
  containerStyle: {
    width: '300px',
    overflowWrap: 'break-word',
  },
} satisfies UseToastOptions;
